import http from "../core/http";
const group = 'auction';

export const getInitialDataRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const placeBidRequest = async (data) => {
    return await http.post(`${group}/bid`, data).then(res => res.data).catch(http.defaultCatch);
}
